import { handleApi } from '../utils/handleApi'
import { PRODUCT_SORT } from '../constants/product-sort'
export const state = () => ({
})

export const mutations = {
}

export const actions = {
  getOutStanding(context) {
    return new Promise((resolve, reject) => {
      handleApi(resolve, reject, this.$axios.get('/home/featured-category'), context)
    })
  },
  getDetail(context, params) {
    return new Promise((resolve, reject) => {
      handleApi(resolve, reject, this.$axios.get(`/category/${params.id}`, { params }), context)
    })
  },
  getListProduct(context, data) {
    return new Promise((resolve, reject) => {
      const filters = {
        page: 1,
        order_by: PRODUCT_SORT.POPULAR,
        ...(data.filters || {})
      }

      if (filters.page === undefined || filters.page === null || filters.page === '') {
        filters.page = 1
      }

      if (filters.order_by === undefined || filters.order_by === null || filters.order_by === '') {
        filters.order_by = PRODUCT_SORT.POPULAR
      }

      filters.order_by = Number(filters.order_by)
      if (!Number.isFinite(filters.order_by)) {
        filters.order_by = PRODUCT_SORT.POPULAR
      }

      filters.page = Number(filters.page)
      if (!Number.isFinite(filters.page) || filters.page < 1) {
        filters.page = 1
      }

      handleApi(
        resolve,
        reject,
        this.$axios.get(`/category/${data.id}/products?` + new URLSearchParams(filters).toString()),
        context
      )
    })
  },
  categorySearch(context, params) {
    return new Promise((resolve, reject) => {
      handleApi(resolve, reject, this.$axios.get('/category/search?' + new URLSearchParams(params).toString()), context)
    })
  }
}
